import OrdersTableRow from './OrdersTableRow';

export default OrdersTableRow;
